import * as Icons from "lucide-react";
import { fmtTs } from "@/lib/format";

const show = (v) => {
  if (v == null || v === "") return "—";
  if (v?.toDate || v?.seconds != null) return fmtTs(v);
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
};

// Read-only grid for gateway/system-written fields (Razorpay IDs, amounts, signatures).
export const LockedFields = ({ doc, keys, title = "Gateway / system fields (locked)" }) => (
  <div className="rounded-lg border border-border p-3" data-testid="locked-fields">
    <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground mb-2 flex items-center gap-1"><Icons.Lock className="h-3 w-3" />{title}</p>
    <div className="grid grid-cols-2 gap-x-4 gap-y-1.5">
      {(keys || Object.keys(doc).filter((k) => k !== "id").sort()).map((k) => (
        <div key={k} className="min-w-0">
          <p className="text-[10px] font-mono text-muted-foreground">{k}</p>
          <p className="text-xs text-foreground break-all">{show(doc[k])}</p>
        </div>
      ))}
    </div>
  </div>
);
